import { getExportInstance } from 'utils/jarvisApiClient';

export const getExport = (url, REQ_BODY) => {
  const api = getExportInstance();

  return new Promise((resolve, reject) => {
    const exportMethod = !REQ_BODY ? api.get(url) : api.post(url, REQ_BODY);
    exportMethod
      .then(res => {
        resolve(res);
      })
      .catch(err => reject(err));
  });
};
